import Styles from './Section.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Text from '@hiredigital/ui/Text/Text';

const Section = ({
  children,
  className,
  style,
  title,
  subtitle,
  textColor = undefined,
  textType = undefined,
  titleClass,
  subTitleClass,
}) => {
  return (
    <div className={classNames(Styles.section, className)} style={style}>
      {title && (
        <Text
          element='h2'
          size={Text.Size.SUBHEADLINE_LARGE}
          color={textColor}
          type={textType}
          className={titleClass}>
          {title}
        </Text>
      )}
      {subtitle && (
        <Text
          element='p'
          size={Text.Size.BODY}
          color={textColor}
          type={textType}
          className={subTitleClass}>
          {subtitle}
        </Text>
      )}

      {title ? <div className={Styles.addMargin}>{children}</div> : children}
    </div>
  );
};

Section.Color = Text.Color;
Section.Type = Text.Type;
Section.Styles = Styles;

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
};

export default Section;
